<template>
  <svg
    id="svgelem"
    :width="50"
    :height="50"
    xmlns="http://www.w3.org/2000/svg"
    @mouseover="setHoverRating"
  >
    <polygon
      points="19.8, 2.2, 6.6, 43.56, 39.6, 17.16, 0, 17.16, 33, 43.56"
      :fill="isActive ? '#ffd055' : '#d8d8d8'"
      :data-test="isActive"
    />
  </svg>
</template>

<script setup lang="ts">
import { defineProps, computed, defineEmits, withDefaults } from "vue";

interface Props {
  index: number;
  hoverRating: number;
  rating: number;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits(["setHoverRating"]);

const isActive = computed<boolean>(() => {
  return (
    props.index <= props.hoverRating ||
    (props.hoverRating === 0 && props.index <= props.rating)
  );
});

function setHoverRating() {
  emit("setHoverRating", { index: props.index});
}
</script>

